import React from "react";
import { Grid, TextField } from "@material-ui/core";

const HireITformFields = ({ data }) => {
  return (
    <>
      {data.map((d) => (
        <ITformFields data={d} />
      ))}
    </>
  );
};

const ITformFields = ({ data }) => {
  let { visibility, name, orderDateData, dateCompletedData, uidData } = data;
  let { showUidField } = uidData;
  return (
    <>
      {visibility && (
        <div>
          <Grid xs={12} container className="LRM40">
            <Grid xs={4} style={{ alignSelf: "center" }} className="pr20 mt4">
              <Grid xs={12}>
                <Grid xs={12} className="mbold">
                  {name}
                </Grid>
                <Grid xs={12} className="mt14"></Grid>
              </Grid>
            </Grid>
            <Grid xs={8} container className="pl20">
              <Grid xs={6} className="pr20">
                <Grid xs={12} className="mbold mb14"></Grid>
                <TextFieldComp fields={orderDateData} />
              </Grid>
              <Grid xs={6} className="pl20">
                <Grid xs={12} className="mbold mb14"></Grid>
                <TextFieldComp fields={dateCompletedData} />
              </Grid>
            </Grid>
          </Grid>
          {showUidField && (
            <Grid xs={12} container className="LRM40">
              <Grid xs={4} style={{ alignSelf: "center" }} className="pr20 mt4">
                <Grid xs={12}>
                  <Grid xs={12} className="mbold"></Grid>
                  <Grid xs={12} className="mt14"></Grid>
                </Grid>
              </Grid>
              <Grid xs={8} container className="pl20">
                <Grid xs={6} className="pr20">
                  <Grid xs={12} className="mbold mb14"></Grid>
                  <TextFieldComp fields={uidData} />
                </Grid>
              </Grid>
            </Grid>
          )}
        </div>
      )}
    </>
  );
};

export default HireITformFields;

const TextFieldComp = ({ fields }) => {
  let {
    id,
    isDisabled,
    isRequired,
    value,
    format,
    type,
    placeholder,
    defaultValue,
    onChange,
    inputPropDate,
  } = fields;
  return (
    <>
      <TextField
        id={id}
        type={type}
        required={isRequired}
        disabled={isDisabled}
        onChange={(e) => onChange(e)}
        className="DateTimePicker"
        value={value}
        format={format}
        defaultValue={defaultValue}
        placeholder={placeholder}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          min: new Date(inputPropDate).toDateString().slice(0, 10),
        }}
      />
    </>
  );
};
